import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { of } from 'rxjs';

export const guidesCategoryGuard = (snapshot: ActivatedRouteSnapshot) => {
	const router = inject(Router);

	const category = snapshot.params['category'];
	const isCorrectRoute = isCategoryValid(category);

	if (isCorrectRoute) {
		return of(true);
	} else {
		router.navigate(['/guides']);
		return of(false);
	}
};

const isCategoryValid = (category: string) => {
	const categories = ['subject', 'city', 'career'];

	return categories.includes(category);
};
